import type { ResumeDto } from "@izicvs/dto";
import { AnimatePresence, motion } from "framer-motion";

import { BaseListItem } from "./_components/base-item";
import { ResumeListItem } from "./_components/resume-item";

type Props = {
  resumes: ResumeDto[];
  loading: boolean;
};

export const ListView = ({ resumes, loading }: Props) => (
  <div className="grid gap-y-2">
    {loading &&
      Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="duration-300 animate-in fade-in"
          style={{ animationFillMode: "backwards", animationDelay: `${i * 120}ms` }}
        >
          <BaseListItem className="bg-secondary/40" />
        </div>
      ))}

    <AnimatePresence>
      {resumes.map((resume, index) => (
        <motion.div
          key={resume.id}
          layout
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0, transition: { delay: Math.min(index, 8) * 0.03 } }}
          exit={{ opacity: 0, filter: "blur(8px)", transition: { duration: 0.4 } }}
        >
          <ResumeListItem resume={resume} />
        </motion.div>
      ))}
    </AnimatePresence>
  </div>
);
